/*
 Idea based on: https://github.com/antoinevastel/fp-collect/blob/master/src/fpCollect.js
 */

import { checkIsNightmareJS, checkIsPhantomJS, checkIsSelenium, checkIsWebDriver } from '@/bot-detection/checks.ts';
import { SHEEP_STATE } from '@/const/general.ts';
import { getLogger } from '@/logger';

type ValueOf<T> = T[keyof T];
type AutomatedBrowserCheckResult = ValueOf<typeof SHEEP_STATE>;

const logger = getLogger('checkIsAutomatedBrowser');
let cachedResult: AutomatedBrowserCheckResult | null = null;

function performAutomatedBrowserChecks(): AutomatedBrowserCheckResult {
  // Ninja runs in SSR context
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    logger.debug('SSR context detected, returning HUMAN state');

    return SHEEP_STATE.HUMAN;
  }

  try {
    const checkFns = [checkIsWebDriver, checkIsNightmareJS, checkIsPhantomJS, checkIsSelenium];
    if (checkFns.some(fn => fn())) {
      return SHEEP_STATE.BOT;
    }
    return SHEEP_STATE.HUMAN;
  } catch (error) {
    logger.debug('Error occurred while checking automation', error);
  }

  return SHEEP_STATE.UNKNOWN;
}

export function checkIsAutomatedBrowser(): AutomatedBrowserCheckResult {
  if (cachedResult === null) {
    cachedResult = performAutomatedBrowserChecks();
  }

  return cachedResult;
}

export function resetAutomatedBrowserCheckCache() {
  cachedResult = null;
}
